module.exports = __webpack_public_path__ + "static/media/kishoricreation.ada3f7f1.jpg";